import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent } from '@icms/core/content';
import { CMS_HOTSPOTS_CONFIG } from './cms-hotspots.config';
import { NCmsHotspots } from './cms-hotspots.interface';
import { CmsHotspotsWrapperComponent } from './wrapper/hotspots-wrapper.component';

@Component({
    selector: 'cms-hotspots',
    templateUrl: './cms-hotspots.component.html',
    standalone: true,
    imports: [ICmsClientModule, CmsHotspotsWrapperComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<CmsHotspotsComponent>(CMS_HOTSPOTS_CONFIG)
export class CmsHotspotsComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: NCmsHotspots.IComponentData;
}
